import React from "react";
import { KEY_ESC } from "../../lib";
import { Progress } from "../../lib/ui";
import { Translate } from "../../models";
import { eventEmitter } from "../../services";
import {
    cache,
    EVT_LTR_MOUSEOVER,
    EVT_LTR_MOUSEOUT,
    EVT_RTL_MOUSEOVER,
    EVT_RTL_MOUSEOUT,
    setFocusClass,
} from "./helpers";
import { RTL } from "./styles";

type Props = {
    loading: boolean;
    dst: string[];
    src: string[];
    src_lang: string;
    dst_lang: string;

    update: (editIndex: number, dst_text: string) => void;
};
type State = {
    editIndex: number;
};

export default class RTLView extends React.Component<Props, State> {
    private elm: React.RefObject<HTMLDivElement>;

    constructor(props: Props) {
        super(props);
        this.state = {
            editIndex: -1,
        };

        this.elm = React.createRef<HTMLDivElement>();
    }

    componentDidMount() {
        eventEmitter.on(EVT_LTR_MOUSEOVER, (index: number) => {
            if (this.elm && this.elm.current) {
                setFocusClass(this.elm.current, index, true);
            }
        });

        eventEmitter.on(EVT_LTR_MOUSEOUT, (index: number) => {
            if (this.elm && this.elm.current) {
                setFocusClass(this.elm.current, index, false);
            }
        });
    }

    onBlur = async (evt: React.FocusEvent<HTMLDivElement>) => {
        const { editIndex } = this.state;
        const { src, src_lang, dst_lang } = this.props;
        const src_text = src[editIndex];
        const dst_text = evt.target.innerText;

        cache[src_lang][dst_lang][src_text] = dst_text;
        await Translate.save({ dst_text, src_text }, "", {
            src_lang,
            dst_lang,
        });

        this.setState({ editIndex: -1 });
        this.props.update(editIndex, dst_text);
    };

    onKeyUp = (evt: React.KeyboardEvent<HTMLDivElement>) => {
        if (evt.key === KEY_ESC) {
            (evt.target as HTMLElement).blur();
        }
    };

    onClick = (editIndex: number) => this.setState({ editIndex });

    onMouseOut = (index: number) => eventEmitter.emit(EVT_RTL_MOUSEOUT, index);
    onMouseOver = (index: number) =>
        eventEmitter.emit(EVT_RTL_MOUSEOVER, index);

    html() {
        return {
            __html: this.props.dst[this.state.editIndex],
        };
    }

    view() {
        if (this.props.loading) {
            return <Progress margin="40px 0" />;
        }

        const { editIndex } = this.state;
        const { dst } = this.props;
        return dst.map((text, i) => {
            if (editIndex === i) {
                return (
                    <div
                        key={`dst-${i}`}
                        contentEditable={true}
                        ref={(c) => c && c.focus()}
                        onBlur={this.onBlur}
                        onKeyUp={this.onKeyUp}
                        dangerouslySetInnerHTML={this.html()}
                    />
                );
            }

            return (
                <div
                    key={`dst-${i}`}
                    onClick={() => this.onClick(i)}
                    onMouseOut={() => this.onMouseOut(i)}
                    onMouseOver={() => this.onMouseOver(i)}
                >
                    {text}
                </div>
            );
        });
    }
    render() {
        return <RTL ref={this.elm}>{this.view()}</RTL>;
    }
}
